var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.banner)?_c('div',{class:[
    'banner-canvas',
    'aspect-' + _vm.aspect,
    'disposition-' + _vm.banner.disposition,
    'theme-' + _vm.banner.theme,
    'banner-background-' + _vm.banner.mode,
    'logo-' + _vm.banner.logo,
    { 'desaturate': _vm.banner.blackAndWhite && _vm.banner.picture }
  ],attrs:{"id":'bannerCanvas' + _vm.aspect}},[_c('banner-picture',{attrs:{"picture-position":_vm.backgroundPosition,"height":_vm.aspect === '11' ? 500 : 730,"edge":_vm.aspect === '916'}}),_c('headline-card',{attrs:{"headline":_vm.$options.filters.formatString(_vm.banner.headline),"font-size":_vm.headlineFontSize}}),_c('emojis-on-canvas',{model:{value:(_vm.banner.emojis),callback:function ($$v) {_vm.$set(_vm.banner, "emojis", $$v)},expression:"banner.emojis"}}),_c('banner-frame')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }